import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CashCreditComponent } from './cash-credit/cash-credit.component';
import { FormsModule } from '@angular/forms';
import { NouisliderModule } from 'ng2-nouislider';
import { ZestCommonModule } from 'app/common/common.module';
import { MaterializeModule } from 'angular2-materialize';

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    ZestCommonModule,
    NouisliderModule,
    MaterializeModule
  ],
  declarations: [
    CashCreditComponent
  ],
  exports: [
    CashCreditComponent
  ]
})
export class CashCreditModule { }
